import type { ReactElement } from "react";
import clmWordmark from "@/assets/brand/clm-wordmark.svg";
import { cn } from "@/shared/utils/cn";

/**
 * Branded header for the public auth interstitials (011-24): the CLM wordmark
 * only, per the 2026-08-24 designer ruling (the six-brand logo grid from the
 * outdated shared-Cognito-era frame was removed).
 */
export function PublicBrandHeader({ className }: { className?: string }): ReactElement {
  return (
    <div className={cn("flex flex-col items-center", className)}>
      <img src={clmWordmark} alt="CLM" className="h-14 w-auto" width={200} height={81} />
    </div>
  );
}
